<template>
  <div>
    <div class="flex bg-gray-100 w-full h-screen items-center justify-center">
      <div class="bidding bg-white h-screen flex flex-col">
        <div class="">
          <div class="bg-green-600 text-white p-2 text-center">
            <span class="text-sm uppercase block">{{ reserveMet ? 'Reserve Met' : 'Reserve Not Met' }}</span>
            <span class="text-2xl font-semibold block text-lg">
              <UtilTimer v-if="listing.response.data.end" :datetime="listing.response.data.end" />
            </span>
          </div>
          <div class="flex border-b items-center bg-gray-100">
            <span class="w-2/5 px-2 font-medium">Current Bid</span>
            <input class="p-2 text-lg flex-grow border-l text-lg" :value="highestBid" />
          </div>
          <div class="flex border-b items-center bg-gray-100">
            <span class="w-2/5 px-2 font-medium">Your Max Bid</span>
            <input class="p-2 text-lg flex-grow border-l text-lg" v-model="bid.request.data.price.max" placeholder="Optional" />
          </div>
          <div class="flex items-center bg-gray-100">
            <span class="w-2/5 px-2 font-medium">Your Next Bid</span>
            <input class="p-2 text-lg flex-grow border-l text-lg" v-model="bid.request.data.price.price" />
          </div>

          <div class="flex">
            <div
              @click="incrementBid(i)"
              class="w-1/3 p-2 font-medium bg-gray-800 text-white text-center"
              v-for="i in [10, 50, 100]"
              :key="`increment-${i}`"
            >
              +£{{ i.toFixed(2) }}
            </div>
          </div>
          <div class="flex">
            <div class="w-1/2" v-for="(text, i) in ['Private Bid', 'Public Bid']" :key="`button-${i}`">
              <button
                @click="postBid(i)"
                :class="{ 'border-r border-orange-500': i === 0 }"
                class="bg-orange-400 py-3 px-4 text-center text-gray-700 text-lg w-full"
              >
                {{ text }}
              </button>
            </div>
          </div>
        </div>
        <div class="flex-grow bg-gray-200 overflow-scroll">
          <table class="w-full bg-white table-fixed">
            <tbody>
              <tr class="border-b" v-for="(bid, i) in bids.response.data" :key="`bid-${i}`">
                <td class="w-1/5 p-2">
                  <template v-if="bid.transparent">
                    <span class="inline-block rounded bg-gray-800 h-12 w-12"></span>
                  </template>
                  <template v-else>
                    <span class="inline-block rounded bg-gray-800 h-12 w-12"></span>
                  </template>
                </td>
                <td class="p-2">
                  <template v-if="bid.transparent">
                    <span class="block font-medium">{{ bid.user[0].firstName }} {{ bid.user[0].lastName }}</span>
                    <span class="block">{{ bid.company[0].location[0].region }}</span>
                  </template>
                  <template v-else>
                    <span class="block font-medium">Anonymous Bidder</span>
                    <span class="block">{{ bid.company[0].location[0].region }}</span>
                  </template>
                </td>
                <td class="w-1/5">{{ bid.price.price }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!--
    <input v-model="bid.Price.Price" />
    <input v-model="bid.Price.Max" />
    <button @click="postBid()">Place Bid</button>
    <template v-if="app && listing && bids">
      <div>verified: {{ app.User[0].Verified }}</div>
      <div>status: {{ listing.Status }}</div>
      <div>starting price: {{ listing.Price.Price }}</div>
      <div>reserve price: {{ listing.Price.Reserve }}</div>
      <div>current price: {{ highestBid }}</div>
      <div>reserve met: {{ highestBid >= listing.Price.Reserve }}</div>
      <div>you're winning: {{ app.User[0].UserRef === bids[0].User[0].UserRef }}</div>
      <div>bids: {{ bids.length }}</div>
      <div v-for="(bid, i) in bids" :key="i">
        {{ bid.User[0].FirstName }} - {{ bid.Company[0].Location[0].Region }} - {{ bid.Price.Price }} / {{ bid.Price.Max }}
      </div>
    </template>
    <template v-else>
      Loading
    </template>
    -->
  </div>
</template>

<script>
// @ is an alias to /src
import UtilTimer from '@/components/utilities/UtilTimer'

export default {
  name: 'Bidding',
  components: {
    UtilTimer
  },
  data() {
    return {
      app: this.$call({
        env: 'dev',
        endPoint: 'app.get',
        token: this.$route.query.token
      }),
      listing: this.$call({
        env: 'dev',
        endPoint: 'listings.get',
        request: {
          data: {
            listingRef: this.$route.params.listingRef
          }
        }
      }),
      bids: this.$call({
        env: 'dev',
        endPoint: 'bids.get',
        token: this.$route.query.token,
        request: {
          data: {
            listingRef: this.$route.params.listingRef,
            showAll: 1
          }
        }
      }),
      bid: this.$call({
        env: 'dev',
        endPoint: 'bids.place',
        token: this.$route.query.token,
        method: 'POST',
        request: {
          data: {
            type: 'N',
            companyRef: '',
            listingRef: this.$route.params.listingRef,
            price: {
              price: '',
              max: ''
            },
            termsAgreed: 1
          }
        }
      })
    }
  },
  created() {
    this.getApp()
    this.getListing()
    this.getBids()
  },
  computed: {
    reserveMet() {
      if (!this.bids.response.data.length) return false
      if (!this.listing.response.data.price) return false
      return this.highestBid >= this.listing.response.data.price.reserve
    },
    highestBid() {
      if (!this.bids.response.data.length) {
        return 0
      }
      return Math.max.apply(
        Math,
        this.bids.response.data.map(function(o) {
          return o.price.price
        })
      )
    }
  },
  watch: {
    highestBid(newVal) {
      this.bid.request.data.price.price = newVal + 5
    }
  },
  methods: {
    async getApp() {
      await this.$api(this.app)
    },
    incrementBid(increment) {
      this.bid.request.data.price.price = this.bid.request.data.price.price + increment
    },
    async postBid(i) {
      if (i === 1) {
        this.bid.request.data.transparent = 1
      } else {
        this.bid.request.data.transparent = 0
      }
      this.bid.request.data.companyRef = this.app.response.data.company[0].companyRef
      await this.$api(this.bid)
      this.getBids()
    },
    async getBids() {
      this.$api(this.bids)
    },
    async getListing() {
      await this.$api(this.listing)
    }
  }
}
</script>

<style lang="scss" scoped>
.bidding {
  width: 100%;
  max-width: 460px;
  min-width: 280px;
}
input,
button {
  @apply outline-none;
}
</style>
